import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { logger } from "@/lib/logger";

const PropertyContext = createContext(null);

export function PropertyProvider({ children }) {
  const { user } = useAuth();
  const [properties, setProperties] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    if (!user || user === false) return;
    (async () => {
      try {
        const { data } = await api.get("/properties");
        setProperties(data);
        const stored = localStorage.getItem("hr_property_id");
        if (stored && data.find((p) => p.id === stored)) {
          setSelectedId(stored);
        } else if (data.length > 0) {
          setSelectedId(data[0].id);
          localStorage.setItem("hr_property_id", data[0].id);
        }
      } catch (e) {
        logger.error("Failed to load properties", e);
      }
    })();
  }, [user]);

  const select = useCallback((id) => {
    setSelectedId(id);
    localStorage.setItem("hr_property_id", id);
  }, []);

  const refresh = useCallback(async () => {
    const { data } = await api.get("/properties");
    setProperties(data);
  }, []);

  const selected = useMemo(
    () => properties.find((p) => p.id === selectedId) || null,
    [properties, selectedId]
  );

  const value = useMemo(
    () => ({ properties, selectedId, selected, select, refresh, setProperties }),
    [properties, selectedId, selected, select, refresh]
  );

  return <PropertyContext.Provider value={value}>{children}</PropertyContext.Provider>;
}

export const useProperty = () => useContext(PropertyContext);
